var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(this.ipAddress)?_c('RouterView'):_vm._e(),_c('v-overlay',{attrs:{"value":_vm.processLoading,"opacity":"1","z-index":"999999"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","size":"64"}})],1),(!this.ipAddress)?_c('domain-error'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }